module.exports = __webpack_public_path__ + "static/media/wmgr_set_layout_full.ce1350e8.png";